import { Injectable } from '@angular/core';
import { BaseStoreService } from '@src/app/modules/base';

import { LoyaltyProgramListProduct } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class LpNewProductsStoreService extends BaseStoreService<LoyaltyProgramListProduct[]> {}
